module.exports = __webpack_public_path__ + "img/icon-broken.94c4bb57.svg";